import type {
  DefectFeaturesResponseBody,
  DefectFeatureProperties,
} from '../contracts/defectFeatures';
import type { GeoJsonFeatureCollection, GeoJsonGeometry } from '../geojsonBase';

export function prepareDefectFeaturesForArcGIS(
  collection: DefectFeaturesResponseBody,
): DefectFeaturesResponseBody {
  const features = collection.features.map((feature, index) => ({
    type: 'Feature' as const,
    id: index + 1,
    geometry: feature.geometry,
    properties: {
      ...feature.properties,
      band:
        feature.properties?.band != null ? String(feature.properties.band) : '',
    } as DefectFeatureProperties,
  }));

  return {
    type: 'FeatureCollection',
    features,
  } satisfies GeoJsonFeatureCollection<GeoJsonGeometry, DefectFeatureProperties>;
}

export function createGeoJsonLayerUrl(collection: DefectFeaturesResponseBody): string {
  const prepared = prepareDefectFeaturesForArcGIS(collection);
  const blob = new Blob([JSON.stringify(prepared)], { type: 'application/json' });
  return URL.createObjectURL(blob);
}

export function revokeGeoJsonLayerUrl(url: string): void {
  URL.revokeObjectURL(url);
}
